<template>
  <div class="content mrs-page">
    <!-- ============================================================
         TABLE CARD + TABS: 3 tab CLASS / GROUP / PACKAGE
         ============================================================ -->
    <div class="mrs-table-card row-data">
      <!-- 3 tabs -->
      <el-tabs
        v-model="targetType"
        type="card"
        class="mrs-tabs"
        @tab-click="handleTargetTypeChange"
      >
        <el-tab-pane label="Lớp học" name="CLASS">
          <template slot="label">
            <i class="el-icon-school" /> Lớp học
          </template>
        </el-tab-pane>
        <el-tab-pane label="Nhóm học sinh" name="GROUP">
          <template slot="label">
            <i class="el-icon-user" /> Nhóm học sinh
          </template>
        </el-tab-pane>
        <el-tab-pane label="Gói dịch vụ" name="PACKAGE">
          <template slot="label">
            <i class="el-icon-goods" /> Gói dịch vụ
          </template>
        </el-tab-pane>
      </el-tabs>

      <!-- Bảng dữ liệu -->
      <div class="mrs-table-wrapper">
        <el-table
          v-loading="tableLoading"
          :data="tableData"
          border
          class="sk-table"
          highlight-current-row
          :max-height="$tableMaxHeightSmall"
        >
          <!-- STT -->
          <el-table-column
            label="STT"
            type="index"
            width="55"
            align="center"
            :index="indexMethod"
          />

          <!-- Tên đối tượng -->
          <el-table-column :label="targetColumnLabel" min-width="200">
            <template slot-scope="{ row }">
              <span v-if="row.targetName" class="mrs-target-name">{{ row.targetName }}</span>
              <span v-else class="mrs-text-muted">&mdash; (ID: {{ row.targetId }})</span>
            </template>
          </el-table-column>

          <!-- Khối (chỉ hiện khi targetType = CLASS) -->
          <el-table-column
            v-if="targetType === 'CLASS'"
            label="Khối"
            min-width="140"
          >
            <template slot-scope="{ row }">
              <span v-if="row.gradeName">{{ row.gradeName }}</span>
              <span v-else class="mrs-text-muted">&mdash;</span>
            </template>
          </el-table-column>

          <!-- Loại đối tượng -->
          <el-table-column label="Loại" width="140" align="center">
            <template slot-scope="{ row }">
              <el-tag
                :type="targetTypeTagType(row.targetType)"
                size="mini"
                effect="light"
              >
                {{ targetTypeTagLabel(row.targetType) }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- Số khoản thu đã gán -->
          <el-table-column label="Số khoản đăng ký" width="200" align="center">
            <template slot-scope="{ row }">
              <span class="mrs-revenue-count">
                {{ row.numberOfRegisteredRevenues }}
              </span>
            </template>
          </el-table-column>

          <!-- Thao tác -->
          <el-table-column label="Tác vụ" width="160" align="center" fixed="right">
            <template slot-scope="{ row }">
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  plain
                  @click="openDetailDialog(row)"
                >
                  Thêm khoản thu
                </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- Phân trang -->
      <div class="mrs-pagination">
        <el-pagination
          background
          :current-page.sync="pagination.page"
          :page-sizes="[25, 50, 100]"
          :page-size.sync="pagination.size"
          :total="pagination.total"
          layout="sizes, prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </div>

    <!-- ============================================================
         DIALOG Thêm khoản thu
         ============================================================ -->
    <revenue-scope-detail-dialog
      ref="detailDialog"
      @saved="fetchData"
    />
  </div>
</template>

<script>
import RevenueScopeService from "@/services/tutition_v3/RevenueScopeService";
import RevenueScopeDetailDialog from "@/components/tutition_v3/dialog/RevenueScopeDetailDialog.vue";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

const TARGET_TYPE_LABELS = {
  CLASS: "Lớp học",
  GROUP: "Nhóm học sinh",
  PACKAGE: "Gói dịch vụ",
};

export default {
  name: "ManagingRevenueScope",
  components: { RevenueScopeDetailDialog },

  data() {
    return {
      tableLoading: false,
      tableData: [],
      targetType: "CLASS",
      pagination: { page: 1, size: 25, total: 0 },
    };
  },

  computed: {
    targetColumnLabel() {
      const map = {
        CLASS: "Tên lớp",
        GROUP: "Tên nhóm",
        PACKAGE: "Tên gói",
      };
      return map[this.targetType] || "Tên đối tượng";
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    // ─── Helpers ──────────────────────────────────────────────────
    indexMethod(index) {
      return (this.pagination.page - 1) * this.pagination.size + index + 1;
    },

    targetTypeTagLabel(type) {
      return TARGET_TYPE_LABELS[type] || type || "—";
    },

    targetTypeTagType(type) {
      const map = { CLASS: "primary", GROUP: "success", PACKAGE: "warning" };
      return map[type] || "info";
    },

    // ─── API ──────────────────────────────────────────────────────
    async fetchData() {
      this.tableLoading = true;
      try {
        const res = await RevenueScopeService.getTargets({
          targetType: this.targetType,
          page: this.pagination.page - 1,
          size: this.pagination.size,
        });
        const payload = res.data && res.data.data;
        if (Array.isArray(payload)) {
          this.tableData = payload;
          this.pagination.total = payload.length;
        } else if (payload && Array.isArray(payload.content)) {
          this.tableData = payload.content;
          this.pagination.total = payload.totalElements || 0;
        } else {
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (err) {
        NotifyMessage.leftCornerNotificationError(
          (err && err.response && err.response.data && err.response.data.message) ||
            "Không thể tải danh sách đối tượng!"
        );
      } finally {
        this.tableLoading = false;
      }
    },

    handleTargetTypeChange() {
      this.pagination.page = 1;
      this.fetchData();
    },

    handleSizeChange(size) {
      this.pagination.size = size;
      this.pagination.page = 1;
      this.fetchData();
    },

    handlePageChange(page) {
      this.pagination.page = page;
      this.fetchData();
    },

    // ─── Mở dialog ────────────────────────────────────────────────
    openDetailDialog(row) {
      this.$refs.detailDialog.open({
        targetId: row.targetId,
        targetType: row.targetType,
        targetName: row.targetName || "ID: " + row.targetId,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-table.scss";

.mrs-page {
  padding: 4px 0 16px;

  .row-data {
    margin-bottom: 20px;
  }
}

/* ─── Table card ───────────────────────────────────── */
.mrs-table-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
  padding: 18px 18px 14px;
}

/* ─── Tabs (kiểu card – giống TuitionManagement) ──── */
/deep/ .mrs-tabs .el-tabs__nav {
  background: transparent;
  border: none;
}

/deep/ .mrs-tabs .el-tabs__nav-wrap::after {
  background: #2563eb;
  height: 2px;
}

/* Tab chưa chọn: nền xám, chữ xám đậm */
/deep/ .mrs-tabs .el-tabs__item {
  background: #e5e7eb;
  color: #4b5563;
  font-weight: 600;
  border: 1px solid #d1d5db !important;
  border-bottom: none !important;
  border-radius: 8px 8px 0 0;
  transition: background 0.15s, color 0.15s;

  i { margin-right: 6px; }
}

/deep/ .mrs-tabs .el-tabs__item:hover:not(.is-active) {
  color: #1e293b;
  background: #d1d5db;
}

/* Tab được chọn: đồng màu với tiêu đề bảng */
/deep/ .mrs-tabs .el-tabs__item.is-active {
  color: #ffffff !important;
  background: #2563eb !important;
  border-color: #2563eb !important;
}

/deep/ .mrs-tabs .el-tabs__nav-scroll {
  float: right;
}

/deep/ .mrs-tabs .el-tabs__header {
  margin-bottom: 0;
  border-bottom: none;
}

/deep/ .mrs-tabs.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #2563eb;
}

/deep/ .mrs-tabs.el-tabs--card > .el-tabs__header {
  border-bottom: none;
  margin-bottom: 0;
}

/* ─── Bảng ────────────────────────────────────────── */
.mrs-table-wrapper {
  border-radius: 14px;
  overflow: hidden;
}

.mrs-target-name {
  font-size: 13.5px;
  color: #1e293b;
  font-weight: 500;
}

.mrs-text-muted { color: #94a3b8; font-size: 13px; }

/* Badge số khoản đăng ký */
.mrs-revenue-count {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: #eff6ff;
  color: #2563eb;
  font-weight: 700;
  font-size: 13px;
  padding: 3px 12px;
  border-radius: 20px;
  border: 1px solid #bfdbfe;

  i { font-size: 13px; }
}

/* Tiêu đề cột bảng: nền xanh đậm */
/deep/ .sk-table thead th,
/deep/ .sk-table thead td {
  background: #2563eb !important;
  color: #ffffff !important;
  font-weight: 700;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
/deep/ .sk-table thead th > .cell,
/deep/ .sk-table thead td > .cell {
  color: #ffffff !important;
  font-weight: 700;
}
/deep/ .sk-table thead tr { height: 56px; }
/deep/ .sk-table tbody td { background: #ffffff; }

/* ─── Phân trang ──────────────────────────────────── */
.mrs-pagination {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

/* ─── Button bo góc ──────────────────────────────── */
/deep/ .mrs-page .el-button { border-radius: 10px; }

/* ─── Responsive ──────────────────────────────────── */
@media (max-width: 768px) {
  /deep/ .mrs-tabs .el-tabs__item {
    padding: 0 12px;
    font-size: 13px;
  }
}
</style>

